module.exports = require("defclass");


//////////////////
// WEBPACK FOOTER
// external "defclass"
// module id = 7
// module chunks = 0